// extracted by mini-css-extract-plugin
export default {"reminder":"AttachmentReminder_reminder__z3GFm","text":"AttachmentReminder_text__cPL6f","icon":"AttachmentReminder_icon__cE1t3"};